var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#50BEE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22906 30.0002C6.89906 30.0002 6.53906 29.819 6.53906 29.3802V23.704C6.53906 23.344 6.89906 23.084 7.22906 23.084H9.51781C14.0853 23.084 13.9841 30.0002 9.60656 30.0002H7.22906ZM7.85906 24.3027V28.7802H9.51781C12.2166 28.7802 12.3353 24.3027 9.51781 24.3027H7.85906Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 30.1002C15.9591 30.1802 14.0391 28.9502 14.0391 26.5015C14.0391 24.0427 15.9578 22.834 17.8078 22.834C19.5566 22.9227 21.3853 24.1327 21.3853 26.5015C21.3853 28.8715 19.5566 30.1002 17.8078 30.1002ZM17.6978 24.134C16.5778 24.134 15.3591 24.924 15.3591 26.5027C15.3591 28.0727 16.5791 28.8727 17.6978 28.8727C18.8478 28.8727 20.0766 28.0727 20.0766 26.5027C20.0766 24.9227 18.8478 24.134 17.6978 24.134Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5625 26.4918C22.5625 24.563 23.7725 22.9043 26.0713 22.9043C26.9413 22.9043 27.6313 23.1643 28.36 23.7943C28.63 24.043 28.66 24.483 28.39 24.763C28.12 25.0018 27.71 24.973 27.47 24.733C27.0613 24.303 26.6413 24.1843 26.0713 24.1843C24.5325 24.1843 23.7938 25.2743 23.7938 26.493C23.7938 27.733 24.5225 28.8718 26.0713 28.8718C26.6413 28.8718 27.1713 28.6405 27.6313 28.2318C27.94 27.9918 28.37 28.1105 28.55 28.3518C28.71 28.5718 28.7887 28.9418 28.44 29.2905C27.74 29.9418 26.9012 30.0718 26.07 30.0718C23.6525 30.0718 22.5625 28.4205 22.5625 26.4918Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeDocs);
export default __webpack_public_path__ + "static/media/large_docs.a7bccf06c15b8b075c40a93513bf2c5b.svg";
export { ForwardRef as ReactComponent };